import { ActionLink, UIHeading4 } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './PurchaseTerms.css';

interface IPurchaseTermsProps {
  onClick: () => void;
}

export const PurchaseTerms: React.FC<IPurchaseTermsProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <UIHeading4 color="text-primary-default">100% оплата</UIHeading4>
      <ActionLink
        color="current_color"
        onClick={onClick}
        afterIcon={<IconActionChevronRightSmall16 color="current_color" />}
        fontSize="M"
        fontWeight="bold"
        data-testid="PurchaseTermsButton"
      >
        Ещё способы покупки
      </ActionLink>
    </div>
  );
};
